"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountdownProvider = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var react_1 = require("react");
/**
 * CountdownProvider updates a child render function with time values,
 * given an initialTimeRemaining
 *
 * Copied and modified from:
 * https://github.com/uken/react-countdown-timer
 *
 */
var CountdownProvider = /** @class */ (function (_super) {
    __extends(CountdownProvider, _super);
    function CountdownProvider(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.state = {
            timeRemaining: props.initialTimeRemaining,
            timeoutId: null,
            prevTime: null,
        };
        _this.tick = _this.tick.bind(_this);
        return _this;
    }
    /**
     * Start the countdown when ready.
     */
    CountdownProvider.prototype.componentDidMount = function () {
        this.tick();
    };
    CountdownProvider.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.initialTimeRemaining !== this.props.initialTimeRemaining) {
            if (prevState.timeoutId) {
                window.clearTimeout(prevState.timeoutId);
            }
            this.setState({
                timeRemaining: this.props.initialTimeRemaining,
                prevTime: null,
            });
        }
        if (!this.state.prevTime && this.state.timeRemaining > 0) {
            this.tick();
        }
    };
    /**
     * Stop the timer before the component unmounts.
     */
    CountdownProvider.prototype.componentWillUnmount = function () {
        if (this.state.timeoutId) {
            window.clearTimeout(this.state.timeoutId);
        }
    };
    CountdownProvider.prototype.getTimeRemaining = function () {
        var timeRemaining = this.state.timeRemaining;
        var totalSeconds = Math.round(timeRemaining / 1000);
        var seconds = totalSeconds % 60;
        var minutes = Math.floor(totalSeconds / 60) % 60;
        var hours = Math.floor(totalSeconds / 3600) % 24;
        var days = Math.floor(totalSeconds / 86400);
        return { days: days, hours: hours, minutes: minutes, seconds: seconds };
    };
    /**
     * Update the timer based on the provided interval and run any requested
     * callbacks.
     */
    CountdownProvider.prototype.tick = function () {
        var currentTime = Date.now();
        var dt = this.state.prevTime ? currentTime - this.state.prevTime : 0;
        var interval = this.props.interval;
        // correct for small variations in actual timeout time
        var timeRemainingInInterval = interval - (dt % interval);
        var timeout = timeRemainingInInterval;
        if (timeRemainingInInterval < interval / 2.0) {
            timeout += interval;
        }
        var timeRemaining = Math.max(this.state.timeRemaining - dt, 0);
        var countdownComplete = this.state.prevTime && timeRemaining <= 0;
        if (this.state.timeoutId) {
            window.clearTimeout(this.state.timeoutId);
        }
        this.setState({
            timeoutId: countdownComplete ? null : window.setTimeout(this.tick, timeout),
            prevTime: currentTime,
            timeRemaining: timeRemaining,
        });
    };
    CountdownProvider.prototype.render = function () {
        return this.props.children(this.getTimeRemaining());
    };
    CountdownProvider.defaultProps = {
        // Assuming that we want seconds to tick, we default to a value < 1000
        interval: 189,
    };
    return CountdownProvider;
}(react_1.Component));
exports.CountdownProvider = CountdownProvider;
//# sourceMappingURL=CountdownProvider.js.map